import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useStyles } from './FrequentlyAskedQuestionsAccordion.styles';
import useWindowDimensions from '../../helpers/hooks/useWindowDimensions';
import { I18nDOMTransformer } from '../utils/I18nDOMTransformer';
import { sendAnalyticsEvent } from '../Analytics/utilities';

interface FrequentlyAskedQuestionsAccordionProps {
  summary: string;
  details: string;
  location: string;
  questionKey: string;
}

const FrequentlyAskedQuestionsAccordion = ({
  summary,
  details,
  location,
  questionKey,
}: FrequentlyAskedQuestionsAccordionProps) => {
  const [expanded, setExpanded] = useState(false);
  const [accordionHeight, setAccordionHeight] = useState(56);
  const { windowWidth } = useWindowDimensions();
  const classes = useStyles({ expanded, accordionHeight });
  const summaryRef = useRef(null);
  const detailsRef = useRef(null);

  useEffect(() => {
    if (expanded) {
      sendAnalyticsEvent('Opened FAQ', questionKey, 'Click', {
        Location: location,
        Summary: summary,
        Details: details,
      });
      setAccordionHeight(
        Number(summaryRef.current?.scrollHeight) +
          Number(detailsRef.current?.scrollHeight)
      );
    } else {
      setAccordionHeight(summaryRef.current?.scrollHeight);
    }
  }, [expanded, windowWidth, summary]);

  return (
    <Box className={classes.accordion}>
      <Box
        data-test-id="accordion-summary"
        className={classes.accordionSummary}
        onClick={() => setExpanded((currExpanded) => !currExpanded)}
        {...{ ref: summaryRef }}
      >
        <Typography component="h3" className={classes.summary}>
          <I18nDOMTransformer text={summary} analyticsLabel="FAQ" />
        </Typography>
        <Box className={classes.expandMoreIcon}>
          <ExpandMoreIcon />
        </Box>
      </Box>
      <Box className={classes.accordionDetails} {...{ ref: detailsRef }}>
        <Typography component="span" className={classes.details}>
          <I18nDOMTransformer text={details} analyticsLabel="FAQ" />
        </Typography>
      </Box>
    </Box>
  );
};

export default FrequentlyAskedQuestionsAccordion;
